module.exports = __webpack_public_path__ + "img/one.7b855ba4.jpg";